import type { NcIconProps } from "./nc-icon";
import { NcIcon } from "./nc-icon";

const NcIconHistoryPlus = (props: NcIconProps) => (
  <NcIcon xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12h2a8 8 0 1 0 1.385-4.5H8v2H2v-6h2V6a9.99 9.99 0 0 1 8-4"
    />
    <path fill="currentColor" d="M13.5 10.5H16v3h-2.5V16h-3v-2.5H8v-3h2.5V8h3z" />
  </NcIcon>
);
export { NcIconHistoryPlus };
